import { componentInterface } from '@ardoq/component-interface';
import { type ScopeDataParams } from '@ardoq/graph';
import { type EnhancedScopeData } from '@ardoq/data-model';
import { componentUtils } from '@ardoq/scope-data';

/**
 * This is a temporary solution to make the transition from BB models to scope data easier.
 *
 * The next step is to create an object with functions that have the same signature as the model interface functions,
 * but are bound to the current scope data. This way we can use the scopeData or BB models interchangeably with minimal
 * refactoring. As soon BB models are no more, we shall pass the scope data instead of the interface object and use the
 * utility functions directly.
 *
 */

export type BubbleChartSpecificInterface = ReturnType<
  typeof getBubbleChartSpecificInterfaceWithModelInterfaces
>;

export const getBubbleChartSpecificInterfaceWithModelInterfaces = () => ({
  getComponentLevel: componentInterface.getLevel,
});

const getBubbleChartSpecificInterfaceForEnhancedScopeData = (
  enhancedScopeData: EnhancedScopeData
): BubbleChartSpecificInterface => ({
  getComponentLevel: componentId =>
    componentUtils.getLevel(enhancedScopeData, componentId),
});

export const getBubbleChartSpecificInterface = (
  args?: ScopeDataParams
): BubbleChartSpecificInterface => {
  if (args) {
    return getBubbleChartSpecificInterfaceForEnhancedScopeData(
      args.enhancedScopeData
    );
  }

  return getBubbleChartSpecificInterfaceWithModelInterfaces();
};
